/**
 * @desc 创建暂存区
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StagingAreaMasterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/addStagingMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
